<template lang="pug">
  include /mixins
  +b.g-row.--appearance_spaced.--align_center.--space_sm
    +b.g-cell.g-cols.--auto-xs
      d-control-static-datepicker(
        v-model='checked'
        :config="datepickerConfig"
        :placeholder="labels.dateRange"
        autocomplete="off"
        name='dateRange'
        append-icon="icon-date is-events-none"
        @on-change="changeHandler"
      )
</template>

<script>
import { debounce, isEqual } from 'lodash'

export default {
  name: 'DateRangeWidget',

  props: {
    value: {},
    filter: {},
  },

  data() {
    return {
      checked: null,
      isSelectingRange: false,
      debounceFn: () => {},
      labels: {
        dateRange: this._('Период'),
      },
    }
  },

  computed: {
    datepickerConfig() {
      return {
        mode: 'range',
        rangeSeparator: ' — ',
        onChange: this.onFlatpickrChange,
        onClose: this.onFlatpickrClose,
      }
    },
  },

  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(nval, oval) {
        this.setValue(nval, oval)
      },
    },
  },

  mounted() {
    this.debounceFn = debounce(this.submit, 200)
  },

  methods: {
    filterValue(val) {
      return (val || []).filter(e => e)
    },

    valueToInput(value) {
      const normalized = this.normalizeValue(value)

      if (!normalized.length) {
        return null
      }

      return normalized.join(' - ')
    },

    normalizeValue(value) {
      if (!value) {
        return []
      }

      if (Array.isArray(value)) {
        return value.filter(Boolean)
      }

      if ('string' === typeof value) {
        return value
          .split(/\s+to\s+|\s+—\s+|\s+-\s+/)
          .map(item => item.trim())
          .filter(Boolean)
      }

      return []
    },

    setValue(nval, oval) {
      const newValue = this.filterValue(nval)
      const oldValue = this.filterValue(oval)

      if (!isEqual(newValue, oldValue)) {
        this.$set(this, 'checked', this.valueToInput(nval))
      }
    },

    onFlatpickrChange(selectedDates, dateStr) {
      const value = this.normalizeValue(dateStr)

      if (2 <= value.length) {
        this.debounceFn(value)
      }
    },

    onFlatpickrClose(selectedDates, dateStr) {
      const value = this.normalizeValue(dateStr)

      if (!value.length) {
        this.$emit('input', [])
        return
      }

      if (1 === value.length) {
        this.debounceFn([value[0], value[0]])
        return
      }

      this.debounceFn(value)
    },

    changeHandler() {
      console.log('wrapper checked:', this.checked)
    },

    submit(value) {
      const normalized = this.normalizeValue(value)

      if (!normalized.length) {
        this.$emit('input', [])
        return
      }

      if (2 > normalized.length) {
        return
      }

      this.$nextTick(() => {
        this.$emit('input', normalized)
      })
    },
  },
}
</script>
